import React, { useState, useEffect } from 'react';

import { supabase } from '../../../utils/supabaseClient';
import {News} from "../../../utils/types"; // Adjust the import according to your file structure

interface NewsFormProps {
    news?: News;
    onSave: () => void;
}

const NewsForm: React.FC<NewsFormProps> = ({ news, onSave }) => {
    const [title, setTitle] = useState(news ? news.title : '');
    const [content, setContent] = useState(news ? news.content : '');
    const [image, setImage] = useState<File | null>(null);
    const [category, setCategory] = useState(news ? news.category : '');
    const [uploading, setUploading] = useState(false);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setImage(event.target.files[0]);
        }
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        let imageUrl = news ? news.image : '';
        if (image) {
            setUploading(true);
            const { data, error } = await supabase.storage
                .from('news-images')
                .upload(`public/${image.name}`, image);

            if (error) {
                console.error('Error uploading image:', error.message);
                alert('Error uploading image');
                setUploading(false);
                return;
            }

            imageUrl = data?.path || '';
            setUploading(false);
        }

        const newsData = {
            title,
            content, // Check if this contains HTML tags
            image: imageUrl,
            category,
        };

        console.log('News data to be sent:', newsData);

        if (news) {
            // Update existing news
            const { error } = await supabase
                .from('news')
                .update(newsData)
                .eq('id', news.id);

            if (error) {
                console.error('Error updating news:', error.message);
                alert('Error updating news');
                return;
            }
        } else {
            // Create new news
            const { error } = await supabase
                .from('news')
                .insert([newsData]);

            if (error) {
                console.error('Error creating news:', error.message);
                alert('Error creating news');
                return;
            }
        }

        onSave();
    };


    return (
        <form onSubmit={handleSubmit}>
            <div>
                <label>Title</label>
                <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                />
            </div>
            <div>
                <label>Content</label>
                <textarea
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    required
                />
            </div>
            <div>
                <label>Image</label>
                <input type="file" onChange={handleFileChange} />
                {uploading && <p>Uploading...</p>}
            </div>
            <div>
                <label>Category</label>
                <input
                    type="text"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    required
                />
            </div>
            <button type="submit">{news ? 'Update' : 'Create'} News</button>
        </form>
    );
};

export default NewsForm;
